module.exports = __webpack_public_path__ + "t-rowe-mockup@2x.amVjjg18.png";